import { Notification as customNotification } from '../../components/ui/custom-notification';
import get from 'lodash/get';
import {
  all,
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import axiosConfig from './axiosConfig';
import { CREATE_PROJECT, FETCH_PROJECT_LIST, FETCH_PROJECT_LIST_SUCCESS, FETCH_PROJECT_LIST_FAILURE, UPDATE_PROJECT, UPDATE_PROJECT_SUCCESS, UPDATE_PROJECT_FAILURE, DELETE_PROJECT, DELETE_PROJECT_SUCCESS, DELETE_PROJECT_FAILURE, BULK_DELETE_PROJECTS, BULK_DELETE_PROJECTS_SUCCESS, BULK_DELETE_PROJECTS_FAILURE } from './types';
import { createProjectSuccess, fetchProjectListSuccess, fetchProjectListFailure, updateProjectSuccess, updateProjectFailure, deleteProjectSuccess, deleteProjectFailure, bulkDeleteProjectsSuccess, bulkDeleteProjectsFailure } from './action';


function* createProject({ payload }) {

  try {
    const res = yield axiosConfig.post('/CreateProject', payload);

    customNotification.destroy();
    if (res.status === 200) {
        const responseData = get(res, ['data', 'data'], {});
           
            customNotification.success('Project created Successfully.', 'The project was created successfully.');

        return responseData

    }

    else {

        customNotification.error('Something went wrong.', 'Project creation failed.');
        return null

    }


} catch (error) {

    customNotification.destroy();
    customNotification.error('Update Submission Failed.', `${error}`);
    return null

}
}

function* fetchProjectList(payload = {}) {

  try {

    let url;
    // If projectId is provided, get specific project by ID
    if(payload.projectId){
      url = `project/getProjectById/${payload?.projectId}`;
    }
    // If userId is provided (for user/viewer roles), filter projects by userId
    else if(payload.userId){
      url = `project/getAllProjects?userId=${payload.userId}`;
    }
    // For super_admin and admin, get all projects without filter
    else{
      url = `project/getAllProjects`;
    }

  

    if (url) {
      const res = yield axiosConfig.get(url);
      if (res.status === 200)
         {

       const responseData = get(res, ['data', 'data'], {});
       console.log('responseData', responseData);

      
  
        yield put(fetchProjectListSuccess({ responseData }));

      }
    }
    else {
      yield put(fetchProjectListFailure());
      customNotification.error('Something went wrong.', 'Failed to fetch project list.');
    }

  } catch (error) {
    yield put(fetchProjectListFailure());
    customNotification.destroy();
    customNotification.error('A problem occurred while fetching the project list.', `${error.message}`);
  }
}

function* updateProject({ payload }) {

  try {
    const res = yield axiosConfig.put(`/project/update/${payload.id}`, payload);

    customNotification.destroy();
    
    if (res.status === 200) {
        const responseData = get(res, ['data', 'data'], payload);
       
        customNotification.success('Project updated Successfully.', 'The project was updated successfully.');

        yield put(updateProjectSuccess({ responseData }));

    } else {
        customNotification.error('Something went wrong.', 'Project update failed.');
        yield put(updateProjectFailure());
    }

  } catch (error) {
    yield put(updateProjectFailure());
    customNotification.destroy();
    customNotification.error('Project update failed.', `${error}`);
  }
}

function* deleteProject({ payload }) {
  try {
    console.log('payload', payload);
    const res = yield axiosConfig.delete(`/project/deleteProject/${payload.projectId}`);

    customNotification.destroy();
    
    if (res.status === 200) {
        customNotification.success('Project deleted Successfully.', 'The project was deleted successfully.');
        yield put(deleteProjectSuccess({ projectId: payload.projectId }));
    } else {
        customNotification.error('Something went wrong.', 'Project deletion failed.');
        yield put(deleteProjectFailure());
    }

  } catch (error) {
    yield put(deleteProjectFailure());
    customNotification.destroy();
    customNotification.error('Project deletion failed.', `${error}`);
  }
}

function* projectWatcher() {
  yield takeLatest(CREATE_PROJECT, createProject);
  yield takeLatest(FETCH_PROJECT_LIST, fetchProjectList);
  yield takeLatest(UPDATE_PROJECT, updateProject);
  yield takeLatest(DELETE_PROJECT, deleteProject);
  yield takeLatest(BULK_DELETE_PROJECTS, bulkDeleteProjects);
}

function* projectSagas() {
  yield all([
    call(projectWatcher),
  ]);
}

export default projectSagas;



export const CreateProject = async (projectData,isEdit) => {
  
  try {
    let res
    let url = '/project/createProject';
    if(isEdit){
      url = `/project/updateProject/${projectData.projectId}`;
    }
    if(isEdit){
      res = await axiosConfig.put(url, projectData);
    }
    else{
      res = await axiosConfig.post(url, projectData);
    } 
    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      customNotification.success(isEdit ? 'Project updated successfully' : 'Project added successfully', '');
      return res.data;
    }
    if (res.status === 502) {
      customNotification.error('Service temporarily unavailable', 'The service is temporarily unavailable. Please try again later.');
      return null;
    }
    return null;
  } catch (error) {
    customNotification.error('Failed to add project', error.message);
    return null;
  }
}


export const AddUserCategory = async (data, type = 'company') => {

  try {
    let url = 'company/createCompany';
    if (type === 'location')
      url = 'location/createLocation';
    const res = await axiosConfig.post(url, data);

    customNotification.destroy();
    if (res.status === 200) {
      const responseData = get(res, ['data', 'data'], {});

      customNotification.success('Added Successfully.', `The ${type} was added successfully.`);

      return responseData

    }

    else {

      customNotification.error('Failed to add  category', `The ${type} was not added.`);
      return null

    }


  } catch (error) {


     customNotification.destroy();
    if(error?.data.includes('Validation error')){
      customNotification.warning( 'Could not add '+ type,  type === 'company' ? `${data.company_name} already exists` : `${data.location_name} already exists`, '');
    }
    else{
      customNotification.error(error.data, '');
    }
    return null

  }
}

export const getListUserCategory = async (type = 'company') => {
  try {
    let url;
  
     if (type === 'company')
      url = `/company/getallcompanies`;

    else if (type === 'location')
      url = `/location/getAllLocations`;


    const res = await axiosConfig.get(url);

    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    } if (res.status === 200) {
      const data = get(res, ['data', 'data'], {});
  
      return data?.data || [];
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getAllContractors = async () => {
  try {
    const res = await axiosConfig.get('/contractor/getAllContractors');
    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return [];
    }
    if (res.status === 200) {
      const payload = get(res, ['data', 'data'], {});
      if (Array.isArray(payload)) {
        return payload;
      }
      return payload?.data || [];
    }
    return [];
  } catch (error) {
    return [];
  }
};

/** Create contractor (omit contractor_id). For updates, include contractor_id per API. */
export const createUpdateContractor = async (payload) => {
  try {
    const res = await axiosConfig.post('/contractor/createUpdateContractor', payload);

    customNotification.destroy();
    if (res.status === 200) {
      const responseData = get(res, ['data', 'data'], {});
      customNotification.success('Added Successfully.', 'The contractor was added successfully.');
      return responseData;
    }
    customNotification.error('Failed to add contractor', 'The contractor was not added.');
    return null;
  } catch (error) {
    customNotification.destroy();
    const errMsg = typeof error?.data === 'string' ? error.data : error?.message || 'Request failed';
    customNotification.error('Failed to add contractor', errMsg);
    return null;
  }
};

export const UpdateProjectStatus = async (projectId, status) => {
  try {
    let res
    let url = `/project/updateProjectMaster/${projectId}`;
   
    res = await axiosConfig.put(url, {progress: status });
    
    if (res.status === 403) {
      customNotification.error('Project not found', 'The project could not be found.');
      return null;
    }
    if (res.status === 200) {
      customNotification.success('Project updated successfully', 'The project status was updated successfully.');
      return res.data;
    }
    if (res.status === 502) {
      customNotification.error('Service temporarily unavailable', 'The service is temporarily unavailable. Please try again later.');
      return null;
    }
    return null;
  } catch (error) {
    customNotification.error('Failed to update project status', error.error);
    return null;
  }
}

export const bulkDeleteProjects = async (payload) => {
  try {

 //   console.log('payload', payload);
    
    const res = await axiosConfig.delete(`/project/bulkDeleteProject`,{data: payload});

    customNotification.destroy();
    
    if (res.status === 200) {
        customNotification.success('Projects deleted Successfully.', `${payload.projectIds.length} project(s) were deleted successfully.`);
        return payload.projectIds;
    } else {
        customNotification.error('Failed to delete projects',res.data.error);
        return null;
    }

  } catch (error) {
    customNotification.destroy();
    customNotification.error('Failed to delete projects', error.error);
    return null;
  }
}